import {createArrayFromObject} from "../Types/arrayUtilities";
import {createLocation} from "./locationUtilities";
import type {AppLocation} from "./locationUtilities";

export const locationBehaviors = {
    doNotRedirectBack: "doNotRedirectBack",
    redirectToDashboard: "redirectToDashboardIfAuthenticated",
    requiresAuthentication: "requiresAuthentication",
    requiresAdminAuthentication: "requiresAdminAuthentication",
};

export const params = {
    barcode: ":barcode",
    libraryCatalogCopyId: ":catalogCopyId",
    libraryCatalogItemId: ":catalogItemId",
    libraryVendorId: ":libraryVendorId",
    loanLibraryManufacturerId: ":loanLibraryManufacturerId",
    loanLibraryLoanId: ":loanLibraryLoanId",
    patronId: ":patronId",
    systemType: ":systemType",
    updatePasswordToken: ":updatePasswordToken",
}

export const locations: Record<string, AppLocation> = {

    // GENERAL LOCATIONS
    LANDING: createLocation(() => `/home`, `Home`, [locationBehaviors.redirectToDashboard]),
    REGISTER: createLocation(() => `/register`, `Register`, []),
    SIGN_IN: createLocation(() => `/sign-in`, `Sign in`, [locationBehaviors.redirectToDashboard]),
    SIGN_OUT: createLocation(() => `/goodbye`, `Sign out`, [locationBehaviors.doNotRedirectBack]),
    DASHBOARD: createLocation(() => `/dashboard`, `Dashboard`, [locationBehaviors.requiresAuthentication]),

    //Library
    LIBRARY_LOAN: createLocation(() => `/library-catalog/1`, `Loan Library`, [locationBehaviors.requiresAuthentication]),

    //Loan Library
    LOAN_LIBRARY_CATALOG: createLocation(() => `/library-catalog/1`, `Loan Library`, [locationBehaviors.requiresAuthentication]),
    LOAN_LIBRARY_CATALOG_ITEM: createLocation((catalogItemId = params.libraryCatalogItemId, systemType = params.systemType) => `/loan-library-catalog-item/${catalogItemId}/${systemType}`, `Loan Library Catalog Item`, [locationBehaviors.requiresAuthentication]),
    LOAN_LIBRARY_QUEUE: createLocation(() => `/loan-library-queue/`, `Loan Library Queue`, [locationBehaviors.requiresAuthentication]),
    LOAN_LIBRARY_HISTORY: createLocation(() => `/loan-library-history/`, `Loan Library History`, [locationBehaviors.requiresAuthentication]),
    LOAN_LIBRARY_LOAN_MANAGEMENT: createLocation(() => `/loan-library/loans/`, `Loan Library Loan Management`, [locationBehaviors.requiresAdminAuthentication]),
    LOAN_LIBRARY_WHATS_NEW: createLocation(() => `/loan-library-whats-new/`, `What's New`, [locationBehaviors.requiresAuthentication]),

    LOAN_LIBRARY_MANUFACTURER: createLocation((manufacturerId = params.loanLibraryManufacturerId) => `/manufacturer/${manufacturerId}`, `Manage Manufacturers`, [locationBehaviors.requiresAdminAuthentication]),
    LIBRARY_VENDOR: createLocation((libraryVendorId = params.libraryVendorId, systemType = params.systemType) => `/library-vendor/${libraryVendorId}/${systemType}`, `Manage Vendors`, [locationBehaviors.requiresAdminAuthentication]),


    SHIPPING_LOCATION_ADD: createLocation(() => `/shipping-location-add`, `Add Shipping Location`, [locationBehaviors.requiresAuthentication]),
    DYMO_PRINT_LABEL: createLocation((catalogCopyId = params.libraryCatalogCopyId) => `/dymo-print-label/${catalogCopyId}/`, `Dymo Print Label`, [locationBehaviors.requiresAuthentication]),

    //Own
    OWN_CATALOG: createLocation(() => `/library-catalog/2`, `Own`, [locationBehaviors.requiresAuthentication]),
    OWN_CATALOG_ITEM: createLocation((ownCatalogItemId = params.libraryCatalogItemId, systemType = params.systemType) => `/own-catalog-item/${ownCatalogItemId}/${systemType}`, `Own Catalog Item`, [locationBehaviors.requiresAuthentication]),
    OWN_QUEUE: createLocation(() => `/own-queue/`, `Own Queue`, [locationBehaviors.requiresAuthentication]),
    OWN_WHATS_NEW: createLocation(() => `/own-whats-new/`, `What's New`, [locationBehaviors.requiresAuthentication]),

    //Own Loan
    OWN_LOAN_MANAGEMENT: createLocation(() => `/own/loans/`, `Own Loan Management`, [locationBehaviors.requiresAdminAuthentication]),
    OWN_LOAN_HISTORY: createLocation(() => `/own/loan-history/`, `Own History`, [locationBehaviors.requiresAuthentication]),

    //Passwords
    FORGOT_PASSWORD: createLocation(() => `/forgot-password`, `Forgot Password`, [locationBehaviors.redirectToDashboard]),
    UPDATE_PASSWORD: createLocation((updatePasswordToken = params.updatePasswordToken) => `/update-password/${updatePasswordToken}`, `Update Password`, [locationBehaviors.redirectToDashboard]),

    //User
    USER_MANAGEMENT: createLocation(() => `/user-management`, `User Management`, [locationBehaviors.requiresAdminAuthentication]),
    USER_PROFILE: createLocation((patronId = params.patronId) => `/user-profile/${patronId}`, `User Profile`, [locationBehaviors.requiresAuthentication]),

    //Reports
    REPORTS: createLocation(() => `/reports`, `Reports`, [locationBehaviors.requiresAdminAuthentication]),

    // Sad paths
    NOT_AUTHORIZED: createLocation(() => `/notAuthorized`, `Not Authorized`, [locationBehaviors.doNotRedirectBack]),
    NOT_FOUND: createLocation(() => `/pageNotFound`, `Not Found`, [locationBehaviors.doNotRedirectBack]),

};

export const allLocations: AppLocation[] = createArrayFromObject(locations);
